module.exports = __webpack_public_path__ + "img/solutions-architecture.22be6883.svg";